<template>
    <form
    id="enquire_form"
    @submit.prevent="submit"
    method="post"
    :class="{'success' : success}"
    class="full">
        
    <div v-if="success" class="message-sent">
        <img alt="Vue logo" src="../assets/Logo-9T-Thick-White.svg"><br>
        <h2>Thank you for your enquiry</h2>
        <p>A member of our team will be in touch shortly.</p>
        <button type="submit" class="bordered" @click="reloadForm">Send another enquiry</button>
    </div>
        
        <span v-if="success" id="form-body"></span>
        <span v-else id="form-body">
       <!-- Google tag manager GCLID offline tracking managed by luux-media.com -->
            <input data-drupal-selector="edit-gclid" type="hidden" name="utm_gclid" value="">
            <input data-drupal-selector="edit-utm-source" type="hidden" name="utm_source" value="">
            <input data-drupal-selector="edit-utm-medium" type="hidden" name="utm_medium" value="">
            <input data-drupal-selector="edit-utm-campaign" type="hidden" name="utm_campaign" value="">
            <input data-drupal-selector="edit-utm-content" type="hidden" name="utm_content" value="">
            <input data-drupal-selector="edit-utm-term" type="hidden" name="utm_term" value="">

            <input type="hidden" name="_token" :value="csrf">
            <div class="grid-container form-concierge"> 
                <div class="input-wrapper statusTitle">
                    <label for="statusTitle">Title</label>
                    <input
                        required
                        type="text"
                        id="statusTitle"
                        class="inline"
                        name="statusTitle"
                        v-model="userData.statusTitle">
                </div>

                <div class="input-wrapper fname">
                    <label for="firstName">First Name</label>
                    <input
                        required
                        type="text"
                        id="firstName"
                        class="inline"
                        name="firstName"
                        v-model="userData.firstName">
                </div>
                <div class="input-wrapper lname">
                    <label for="lastName">Last Name</label>
                    <input
                    required
                    type="text"
                    id="lastName"
                    class="inline"
                    name="lastNme"
                    v-model="userData.lastName">
                </div>
                <div class="input-wrapper email">
                    <label for="email">Email</label>
                    <input                
                        type="email"
                        id="email"
                        required
                        size="35"
                        name="email"
                        v-model="userData.email">
                </div>
                <div class="input-wrapper phone">
                    <label for="phone">Telephone</label>
                    <input
                        required
                        type="text"
                        id="phone"
                        class=""
                        name="phone"
                        v-model="userData.phone"
                        @input="phoneValidation">
                        <div v-if="phoneValidationMessage.message"><small class="inform-tip-message">{{ phoneValidationMessage.message }}</small></div>
                </div>

                <div class="input-wrapper dropdownone callback">
                    <div class="component-container dropdown" @click="showDropDownOne = !showDropDownOne">
                        <!-- <label v-if="!selectedDropDownOne" for="dropdownone">Select your enquiry</label> -->
                         <label v-if="!selectedDropDownOne" >Select your enquiry</label>
                        <div>
                            <span v-if="selectedDropDownOne">{{ selectedDropDownOne.name }}</span>
                        </div>
                        <span class="c-arrow-down" v-if="!showDropDownOne"></span>
                            <span class="c-arrow-up" v-if="showDropDownOne"></span>
                        <ul v-if="showDropDownOne" >
                            <li class="select--option" v-for="option in statusDropDownOnce" :key="option.id" @click="selectDropDownOne(option)">
                            <span>{{ option.name }}</span>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="input-wrapper dropdownone message">
                    <textarea type="message" v-model="userData.message" class="form-control" rows="10" cols="100" style="height: 90px;" required placeholder="Message"
                    name="message" id="message"></textarea>
                    <div class="inform-tip-message" v-if="!isMessageValid">Minimum 10 characters required</div>
                </div>
                <div class="input-wrapper privacy">      
                    <span class="privacy">
                        <label class="checkbox-container">
                            <input type="checkbox" v-model="userData.privacy" name="privacy" value="Agreed" id="privacy" required >
                            <span class="checkmark"></span>    
                        </label>
                        <span>
                        The personal information you provide will be used exclusively to process your request.
                        <br>We won't share your information with third parties.
                        <br>We will not disclose any information to other organisations unless we are required by law to do so or to prevent fraud.</span>
                    </span>
                </div>
            </div>
            
            <button :disabled="!isMessageValid || !phoneValidationMessage.valid" :class="{ 'disabled-button': !isMessageValid || !phoneValidationMessage.valid}" style="width: 100%; margin-top: 10px; font-size: 1rem;" type="submit" id="contact-submit">
                Send enquiry
            </button>
        </span>
    </form>
</template>

<script>
import Vue from 'vue'

export default {
    name: "contact-form-component",
    data() {
        // let currentUrl = window.location.origin + this.$route.fullPath;
        let currentUrl = window.location.href;
        return {
            currentUrl: currentUrl, // Add currentUrl to data
            showOptions: false,
            selectedDropDownOne: '',
            showDropDownOne: false,
            statusDropDownOnce: [
		      { name: "Request an appointment", id: 1 },
		      { name: "Shipping information", id: 2 },
		      { name: "Other question", id: 3 }
		    ],
            userData: {
                form_url: currentUrl,
                form_origin: 'Footer Contact Form',
                title: '',
                statusTitle: '',
                firstName:'',
                lastName: '',
                phone: '',
                name: '',
                model: '',
                sku: '',
                email: '',
                selectedOptionName: '',
                message: '',
                privacy: []
            }, 
            errors: {},
            success: false,
            loaded: true,
            csrf: document.head.querySelector('meta[name="csrf-token"]').content,
        } 
    },
    watch: {
        '$route'(to, from) {
            this.currentUrl = window.location.href; // Update currentUrl when route changes
        }
    },
    computed: {
        phoneValidationMessage() {
            if (this.userData.phone.length > 0) {
                return this.phoneValidation(message);
            }
            return ''; // Return an empty string if no input is provided
        },
        showMergeTooltip () {
            return this.userData.value[1] - this.userData.value[0] < 10000
        },
        isMessageValid() {
                return this.userData.message.length >= 10;
        },
      },
    methods: {
        phoneValidation() {
            const phoneRegex = /^(\+[0-9]+|00[0-9]+)$/; // Regular expression for country code starting with + or 00 followed by numbers
            const numberRegex = /^[0-9+]+$/; // Regular expression for numbers only

            if (this.userData.phone.length > 0) {
                if (numberRegex.test(this.userData.phone)) {
                    if (phoneRegex.test(this.userData.phone)) {
                        return { valid: true, message: '' };
                    } else {
                        return { valid: false, message: 'Invalid phone number. Please provide your country code. e.g. +44 or 0044' };
                    }
                } else {
                    return { valid: false, message: 'Only numbers allowed' };
                }
            } else {
                return { valid: false, message: '' };
            }
        },

        selectDropDownOne(option) {
            this.selectedDropDownOne = option;
            this.userData.selectedOptionName = option.name; // Update the selected option name in userData
        },
        submit() {
                if (this.loaded) {
                    this.loaded = false;
                    this.success = false;
                    this.errors = {};
                     this.$axios.post('/submit', this.userData ).then(response => { 
                        this.userData.form_origin = '';
                        this.userData.title = '';
                        this.userData.statusTitle = '';
                        this.userData.firstName = '';
                        this.userData.lastName = '';
                        this.userData.phone = '';
                        this.userData.model = '';
                        this.userData.sku = '';
                        this.userData.email = '';
                        this.userData.message = '';
                        this.userData.form_url = '';
                        this.userData.privacy = [];
                        this.userData.selectedOptionName = '';
                        this.loaded = true;
                        this.success = true;
                    }).catch(error => {
                      if (error.response.status === 422) {
                          this.errors = error.response.data.errors || {};
                          }
                    });
                }
        },
        reloadForm() {
            this.errors = {};
            this.success = false;
            this.loaded = true;
            this.userData.form_origin = 'Footer Contact Form'; // Reset form_origin to its initial value
            this.userData.form_url = this.currentUrl; // Reset form_url to its initial value
            // this.$forceUpdate(); // Optionally force update the component
          },
      },
 
    }
</script>